const $ = require('jquery');

export default function accordion() {
  $('.js-accordion-btn').on('click', function (e) {
    e.preventDefault();

    $(this).toggleClass('is-active');
    $(this).next('.js-accordion-content').slideToggle();
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/accordion.js